import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';

import { ctxUser } from '@/contexts/UserContext';
import { sendLogoutToFlutter } from '@/components/flutter/Logout';
import { getChatUserId, getToken } from '@/generated/client/chat/chat';
import { useNotificationStore } from '@/stores/notificationstore';

export function Logout() {
  const navigate = useNavigate();
  const userCtx = useContext(ctxUser);
  const clearAllNotifications = useNotificationStore((state) => state.clearAllNotifications);

  useEffect(() => {
    async function logout(explicit: boolean) {
      // TODO cleanup localStorage properly
      localStorage.removeItem('userMessageTimeMillis');
      clearAllNotifications();
      const bio = localStorage.getItem('biometriclogin');
      if (explicit && bio === 'true') localStorage.setItem('biometriclogin', 'false');

      if (window.Logout) {
        if (!explicit) {
          void sendLogoutToFlutter();
        } else {
          try {
            const chatId = await getChatUserId();
            if (chatId.data) {
              const token = await getToken();
              void sendLogoutToFlutter(String(chatId.data), token.data);
            } else {
              void sendLogoutToFlutter();
            }
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
          } catch (e) {
            void sendLogoutToFlutter();
          }
        }
      }
      window.continueTracking = function () {};
      userCtx?.logout();
      await navigate('/');
    }

    void logout(true);
  }, [navigate, userCtx, clearAllNotifications]);

  return null;
}
